__turbopack_context__.v({
  "frame": "BioCoverImage-module__xkjAha__frame",
  "image": "BioCoverImage-module__xkjAha__image",
});
